
import VueSelect from "vue-select";
import { SistemaMixin } from "@/modules/Application";

const CAMPOS = [
  {
    chave: "id_ncm",
    rotulo: "NCM",
    id: "id_ncm",
    relacoes: ["ncm"],
    busca: "getNCM",
  },
  {
    chave: "id_cfop_nfce",
    rotulo: "CFOP NFC-e",
    id: "id_cfop",
    relacoes: ["cfop_nfce", "cfopNfce"],
    busca: "getCFOPByCodigo",
  },
  {
    chave: "id_cst_csosn",
    rotulo: "CST/CSOSN",
    id: "id_cst_csosn",
    relacoes: ["cst_csosn", "cstCsosn"],
    busca: "getCstCsosn",
  },
  {
    chave: "id_cfop",
    rotulo: "CFOP NF-e",
    id: "id_cfop",
    relacoes: ["cfop"],
    busca: "getCFOPByCodigo",
  },
  {
    chave: "id_cest",
    rotulo: "CEST",
    id: "id_cest",
    relacoes: ["cest"],
    busca: "getCESTByCodigo",
  },
  {
    chave: "id_cstpis",
    rotulo: "CST PIS",
    id: "id_cstpis",
    relacoes: ["cst_pis", "cstPis"],
    busca: "getCSTPISByCodigo",
  },
  {
    chave: "id_cstcofins",
    rotulo: "CST COFINS",
    id: "id_cstcofins",
    relacoes: ["cst_cofins", "cstCofins"],
    busca: "getCSTCofinsByCodigo",
  },
];

export default {
  name: "CorrecaoFiscalPreVenda",
  components: { VueSelect },
  mixins: [SistemaMixin],
  props: {
    produto: { type: Object, required: true },
    bloqueado: { type: Boolean, default: false },
  },
  data() {
    return {
      aberto: false,
      carregando: false,
      salvando: false,
      salvo: false,
      erro: "",
      cadastro: null,
      campos: CAMPOS,
      form: {},
      iniciais: {},
      opcoes: {},
      versoesBusca: {},
      perfil: null,
      perfis: [],
      versaoPerfil: 0,
    };
  },
  methods: {
    idSelecao(valor, chave) {
      if (!valor) return null;
      return valor[chave] || valor.id || null;
    },
    relacao(cadastro, campo) {
      return (
        campo.relacoes
          .map((chave) => cadastro[chave])
          .find((valor) => valor && typeof valor === "object") || null
      );
    },
    async abrir() {
      if (this.bloqueado || this.carregando) return;
      this.aberto = true;
      this.carregando = true;
      this.salvo = false;
      this.erro = "";
      this.cadastro = null;
      this.$emit("ocupado", true);
      try {
        const { data } = await this.$http.post("/produtos/find", {
          id: this.produto.id,
        });
        if (!data || Number(data.id) !== Number(this.produto.id))
          throw new Error("Cadastro do produto não encontrado.");
        this.cadastro = data;
        this.perfil =
          data.perfil_tributario ||
          data.perfilTributario ||
          (data.id_perfil_tributario
            ? { id: data.id_perfil_tributario, descricao: "Perfil atual" }
            : null);
        this.iniciais = {
          id_perfil_tributario: data.id_perfil_tributario || null,
        };
        for (const campo of this.campos) {
          const valor = this.relacao(data, campo);
          const id = data[campo.chave] || this.idSelecao(valor, campo.id);
          this.$set(
            this.form,
            campo.chave,
            valor ||
              (id
                ? {
                    [campo.id]: id,
                    codigo: String(id),
                    descricao: "Cadastro atual",
                  }
                : null)
          );
          this.iniciais[campo.chave] = id || null;
          this.$set(this.opcoes, campo.chave, valor ? [valor] : []);
        }
        this.aplicarPerfil(this.perfil);
      } catch (error) {
        this.erro =
          error?.response?.data?.msg ||
          error.message ||
          "Não foi possível carregar os dados fiscais.";
      } finally {
        this.carregando = false;
        this.$emit("ocupado", false);
      }
    },
    herdadoDoPerfil(campo) {
      return (
        campo.chave !== "id_ncm" &&
        !!this.perfil &&
        (this.perfil[campo.chave] != null || !!this.relacao(this.perfil, campo))
      );
    },
    aplicarPerfil(perfil) {
      if (!perfil) return;
      for (const campo of this.campos) {
        const relacao = this.relacao(perfil, campo);
        const id = perfil[campo.chave] || this.idSelecao(relacao, campo.id);
        const valor =
          relacao ||
          (id
            ? {
                [campo.id]: id,
                codigo: String(id),
                descricao: "Perfil tributário",
              }
            : null);
        if (valor && (campo.chave !== "id_ncm" || !this.form.id_ncm))
          this.$set(this.form, campo.chave, valor);
      }
    },
    async pesquisar(campo, busca, loading) {
      const versao = (this.versoesBusca[campo.chave] || 0) + 1;
      this.versoesBusca[campo.chave] = versao;
      loading(true);
      try {
        const opcoes = await this[campo.busca](busca);
        if (this.versoesBusca[campo.chave] === versao)
          this.$set(
            this.opcoes,
            campo.chave,
            Array.isArray(opcoes) ? opcoes : []
          );
      } catch (error) {
        this.erro =
          "Não foi possível pesquisar os códigos fiscais. Tente novamente.";
      } finally {
        loading(false);
      }
    },
    async pesquisarPerfil(busca, loading) {
      const versao = ++this.versaoPerfil;
      loading(true);
      try {
        const perfis = await this.getPerfilTributarioByDescricao(busca);
        if (versao === this.versaoPerfil)
          this.perfis = Array.isArray(perfis) ? perfis : [];
      } catch (error) {
        this.erro = "Não foi possível pesquisar os perfis tributários.";
      } finally {
        loading(false);
      }
    },
    payload() {
      const valores = {
        id_perfil_tributario: this.idSelecao(this.perfil, "id"),
      };
      for (const campo of this.campos) {
        if (!this.herdadoDoPerfil(campo))
          valores[campo.chave] = this.idSelecao(this.form[campo.chave], campo.id);
      }
      const payload = { id: this.produto.id };
      for (const [chave, valor] of Object.entries(valores)) {
        if (String(valor ?? "") !== String(this.iniciais[chave] ?? ""))
          payload[chave] = valor;
      }
      return payload;
    },
    async salvar(reenviar) {
      if (this.bloqueado || this.salvando || !this.cadastro) return;
      if (reenviar) {
        const faltantes = [];
        if (!this.idSelecao(this.form.id_ncm, "id_ncm")) faltantes.push("NCM");
        if (
          !this.idSelecao(this.form.id_cfop_nfce, "id_cfop") &&
          !this.idSelecao(this.form.id_cfop, "id_cfop")
        )
          faltantes.push("CFOP NFC-e");
        if (!this.idSelecao(this.form.id_cst_csosn, "id_cst_csosn"))
          faltantes.push("CST/CSOSN");
        if (faltantes.length) {
          this.erro = `Preencha os campos para reenviar: ${faltantes.join(
            ", "
          )}.`;
          return;
        }
      }
      this.salvando = true;
      this.erro = "";
      this.salvo = false;
      this.$emit("ocupado", true);
      let sucesso = false;
      try {
        const payload = this.payload();
        if (Object.keys(payload).length > 1) {
          const { data } = await this.$http.post(
            "/produtos/update-fiscal-pdv",
            payload
          );
          if (
            !data ||
            data.status === false ||
            Number(data.id) !== Number(this.produto.id)
          )
            throw new Error(data?.msg || "Não foi possível salvar a correção.");
          for (const [chave, valor] of Object.entries(payload))
            if (chave !== "id") this.iniciais[chave] = valor;
          this.salvo = true;
          this.$emit("salvo");
        }
        sucesso = true;
      } catch (error) {
        const validacoes = error?.response?.data?.errors;
        this.erro = validacoes
          ? Object.values(validacoes).flat().join(" ")
          : error?.response?.data?.msg ||
            error?.response?.data?.message ||
            error.message ||
            "Não foi possível salvar a correção.";
      } finally {
        this.salvando = false;
        this.$emit("ocupado", false);
      }
      if (sucesso && reenviar) this.$emit("reenviar");
    },
  },
};
